import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class StandMarsella extends HObject {
  static meshes = []
  static loadRequest = false
  constructor(hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.inQueue = false
  }

  loadObject () {
    let hObject = this
    StandMarsella.loadRequest = true
    BABYLON.SceneLoader.LoadAssetContainerAsync('static/assets/StandMarsella/', 'StandMarsella.babylon', window.scene).then(function (container) {
      for (let i = 0; i < container.meshes.length; i++) {
        container.meshes[i].isVisible = false
      }
      hObject.lod(container.meshes, 3000)
      container.addAllToScene()

      StandMarsella.meshes = container.meshes
    })
  }

  register () {
    this.setupWidgets()
    this.loadContentImages()
    if (StandMarsella.meshes.length) { // Se puede registrar el objeto puesto que ya se pueden crear instancias
      // Se marca que ya queda registrado, para que en un siguiente registro no se registre mas de una vez
      this.registered = true

      let newInstances = []

      for (let i = 0; i < StandMarsella.meshes.length; i++) {

        // Crea clones para los mesh que se definen como widgets (porque no pueden compartir texturas)
        if (this.getIndexWidgetByMeshName(StandMarsella.meshes[i].name) !== -1) {
          newInstances.push(StandMarsella.meshes[i].clone(StandMarsella.meshes[i].name))
          newInstances[newInstances.length - 1].isVisible = true
        }
        else { // Crea instancias para los que no requieren cambiar propiedades
          newInstances.push(StandMarsella.meshes[i].createInstance(StandMarsella.meshes[i].name))
        }
        //Asignando el padre correspondiente en newInstances según la misma relación en el arreglo original meshes
        if (StandMarsella.meshes[i].parent !== undefined) {
          newInstances[i].parent = newInstances.find(mesh => mesh.name === StandMarsella.meshes[i].parent.name)
        }
      }

      this.objectConfigurations(newInstances, false)

      this.afterloadSetup()
    } else {
      if (StandMarsella.loadRequest === false) { // La primera vez que se desea registrar el objeto se debe cargar desde el servidor
        this.loadObject()
      }
      // Se agrega el objeto a la cola para reintentar posteriormente
      if (!this.inQueue) { // Se agrega sólo si aún no se ha agregado a la cola
        this.inQueue = true
        window.hScene.hObjectsRegisterQueue.push(this)
      }
    }
  }

  setupWidgets () {

    let logo1 = {}
    logo1.meshName = 'logo1'
    logo1.maxImages = 1
    this.addWidget(logo1)

    let logo2 = {}
    logo2.meshName = 'logo2'
    logo2.maxImages = 1
    this.addWidget(logo2)

    let monitor1 = {}
    monitor1.meshName = 'monitor1'
    monitor1.maxImages = 5
    this.addWidget(monitor1)

    let monitor2 = {}
    monitor2.meshName = 'monitor2'
    monitor2.maxImages = 5
    this.addWidget(monitor2)

    let monitor3 = {}
    monitor3.meshName = 'monitor3'
    monitor3.maxImages = 5
    this.addWidget(monitor3)

    let banner1 = {}
    banner1.meshName = 'banner1'
    banner1.maxImages = 1
    this.addWidget(banner1)

    let banner2 = {}
    banner2.meshName = 'banner2'
    banner2.maxImages = 1
    this.addWidget(banner2)

    let poster1 = {}
    poster1.meshName = 'poster1'
    poster1.maxImages = 1
    this.addWidget(poster1)

    let poster2 = {}
    poster2.meshName = 'poster2'
    poster2.maxImages = 1
    this.addWidget(poster2)

    let poster3 = {}
    poster3.meshName = 'poster3'
    poster3.maxImages = 1
    this.addWidget(poster3)

    let poster4 = {}
    poster4.meshName = 'poster4'
    poster4.maxImages = 1
    this.addWidget(poster4)

    let triptych = {}
    triptych.meshName = 'triptych'
    triptych.maxImages = 1
    this.addWidget(triptych)

    for(let i=1; i<=8; i++){
      let item = {}
      item.meshName = `item${i}`
      item.maxImages = 1
      this.addWidget(item)
    }
  }

  afterloadSetup () {
    this.setContentFirstImages()

  }

}



// WEBPACK FOOTER //
// ./src/hobjects/StandMarsella.js